import axios from '../plugins/axios'
const state = {
  type : null,
  o_id : null,
  form_errors : [],
  item: {},
  form_name: null,
  bank_name: null,
  project_name: null,
  vendor_name: null,
  item_name: null,
  job_name: null,
  user_name: null,
  customer_name: null,
  log_items : [],
  form_data: {},
  items: [],
  log_list_modal : false,
  log_list_loading : false,
  refresh_log_list: false,
}
const getters = {
  getDataByKey: (state) => (key) => {
    return state[key]
  }
}
const  actions = {
  addLog({commit,getters},data) {
    var formData = new FormData();
    formData.append('type',getters.getDataByKey('type'))
    formData.append('o_id',getters.getDataByKey('o_id'))
    for(var key in data){
      formData.append(key,data[key])
    }
    commit('setLogData',{key : 'log_list_loading',value : true})
    commit('setLogData',{key : 'form_errors',value : []})
    axios.post('log/add',formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(function(res){
      let data = res.data
      if(!data.status){
        commit('setLogData',{key : 'form_errors',value : data.errors})
      }
      if(data.status){
        let item_data = getters.getDataByKey('item')
        item_data.logs_count = item_data.logs_count + 1
        commit('setLogData',{key : 'item',value : item_data})
        commit('setLogData',{key : 'form_errors',value : []})
        commit('setLogData',{key : 'form_data',value : []})
      }
    }).catch(function(){

    })
    .then(function(){
      commit('setLogData',{key : 'log_list_loading',value : false})
    })
  },
  getLogs({commit,getters},data){
    commit('setLogData',{key : 'log_list_loading',value : true})
    let type = getters.getDataByKey('type')
    let o_id = getters.getDataByKey('o_id')
    axios.get('log/list?type='+type+'&o_id='+o_id+'&'+data)
    .then(function(res){
      let data = res.data
      commit('setLogData',{key : 'log_items',value : data.data})
    })
    .then(function(){
      commit('setLogData',{key : 'log_list_loading',value : false})
    })
  }
}
const mutations = {
  setLogData(state,data){
    state[data.key] = data.value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}